import { render, staticRenderFns } from "./detailConcepts.vue?vue&type=template&id=ff1f4d66&scoped=true&"
import script from "./detailConcepts.vue?vue&type=script&lang=js&"
export * from "./detailConcepts.vue?vue&type=script&lang=js&"
import style0 from "./detailConcepts.vue?vue&type=style&index=0&id=ff1f4d66&scoped=true&lang=css&"
import style1 from "./detailConcepts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1f4d66",
  null
  
)

export default component.exports